// extracted by mini-css-extract-plugin
export default {"box":"OurMission_box__V7jK1","video_player":"OurMission_video_player__tJYOk","play":"OurMission_play__mE9KQ","icon":"OurMission_icon__sl-Bn"};